import React from 'react';

const AppContext = React.createContext({
    headless: false,
    path: '/',
    filter: false,
    subscriptionUrl: ''
})
export default AppContext